<template>

  <Header
    label="Aus Liebe zum Theater"
    :headline="coupon.name"
  />

  <section class="bg-white py-20">
    <div class="container lg:flex lg:space-x-20">
      <div class="flex-none lg:w-1/3 mb-8">
        <div class="inline-block bg-white p-1 rounded-md shadow-md max-w-sm w-full">
          <img
            v-if="coupon.cover"
            class="lazy block rounded bg-gray-100 w-full h-auto"
            :data-src="coupon.cover.url"
            :height="coupon.cover.height"
            :width="coupon.cover.width"
            :alt="coupon.name"
          >
          <div v-else class="w-screen pb-[100%] rounded bg-gray-100 max-w-full"></div>
        </div>
      </div>
      <div class="flex-1 max-w-2xl">
        <h1 class="text-2xl text-blue-500 font-bold mb-4 mt-4">{{ coupon.name }}</h1>
        <p v-if="coupon.description" class="text-lg">{{ coupon.description }}</p>
        <hr class="border-gray-300 sm:max-w-[90%] my-8">
        <form @submit.prevent="submit" method="POST" :action="route('cart.product')">
          <template v-if="coupon.options && coupon.options.length">
            <Select label="Variante:" name="option" v-model="form.option" class="w-full sm:w-64">
              <option
                v-for="option in coupon.options"
                :value="option.id"
                :key="option.id"
              >{{ option.name }}</option>
            </Select>
            <hr class="border-gray-300 sm:max-w-[90%] my-8">
          </template>
          <div class="flex items-center justify-between sm:justify-start space-x-8">
            <strong class="text-2xl text-blue-500">{{ formatPrice(price) }}</strong>
            <button
              class="button"
              type="submit"
              data-fb-track="AddToCart"
              :data-fb-data="JSON.stringify({ currency: 'EUR', value: price })"
            >In den Warenkorb</button>
          </div>
        </form>
      </div>
    </div>
  </section>

  <!-- <section class="bg-gradient-to-r from-blue-500 to-blue-accent py-16">
    <div class="container">
      <div class="text-white max-w-2xl mx-auto text-center">
        <h3 class="text-2xl leading-tight font-bold mb-4">
          Print oder kein Print, das ist hier die Frage
        </h3>
        <p class="text-lg">
          Im Checkout haben Sie die Wahl: Lassen Sie sich Ihr Abo als Printprodukt per Post von uns schicken oder erhalten Sie schnell und einfach per E-Mail den für den Ticketkauf benötigten Abo-Code.
        </p>
      </div>
    </div>
  </section> -->

</template>

<script>
import Layout from 'Web/Layouts/WithCart.vue';
import Header from 'Web/Shared/Header.vue';
import Select from 'Web/Form/Fields/SelectField.vue';
import { useForm } from '@inertiajs/inertia-vue3/dist';
import formatPrice from '@/helpers/formatPrice';
import useMeta from '@/compose/meta';
import { ref, watchEffect } from 'vue';

export default {
  inheritAttrs: false,
  layout: Layout,
  components: {
    Header,
    Select,
  },
  props: {
    coupon: Object,
  },
  setup(props) {
    const { assign } = useMeta();

    assign({ title: `DAS DA-Onlineshop - ${props.coupon.name}` });

    const price = ref();

    const form = useForm({
      option: null,
      type: 'coupon',
      id: props.coupon.id,
    });

    const options = props.coupon.options;

    if (options && options.length) {
      form.option = options[0].id;
    }

    watchEffect(() => {
      const options = props.coupon.options;

      if (options && options.length)
        price.value = options.find(option => option.id === form.option)?.price;
      else
        price.value = props.coupon.value
    });

    function submit(event) {
      form.post(event.target.action, {
        preserveScroll: true,
        preserveState: true,
      });
    }

    return {
      formatPrice,
      submit,
      price,
      form,
    }
  }
}
</script>
